module.exports = fox._r("fonts/mc-icons-liveshow.ttf", __webpack_public_path__ + "_/_/_/_/common/liveshow/fonts/3gZrCOJ.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/fonts/mc-icons-liveshow.ttf
// module id = 189
// module chunks = 4